import FetchSettings from "../../interfaces/FetchSettings";
import OracleContentProvider from "./OcontentProvider";

export default class OcontentYoutubeProvider extends OracleContentProvider {
  async getHtml(categorySlug: string): Promise<string> {
    try {
      const url = new URL(
        this.baseUrl + "in-the-news/" + categorySlug + ".txt"
      );
      const settings: FetchSettings = {
        method: "GET",
      };

      const res = await this.request<Response>(url.toString(), settings, true);
      if (res.ok) {
        const html = await res.text();
        return html;
      } else {
        return "";
      }
    } catch (error) {
      console.error(error);
      return "";
    }
  }
}
